<template>
  <div class="showRoom-bg">
    <div class="title">
      {{ $t("算能解决方案 助力数字中国建设，让国产算力普惠千行百业") }}
    </div>
    <div class="subitle">
      {{
        $t("面向丰富的业务场景，提供整套行业和技术解决方案，助力客户数字化转型")
      }}
    </div>
    <div class="main-block">
      <div :key="index" :data-id="item.id" v-for="(item, index) in firstLevel">
        <div
          class="con-item"
          :style="'background-image:url(' + item.coverPicUrl + ')'"
        >
          <div class="sub-list">
            <div class="sub-name">
              <span :class="'iconfont ' + item.icon"></span
              >{{ item.projectName }}
            </div>
            <section
              class="sub-item"
              @click="gotoDetail(subItem.subProjectId)"
              :key="i"
              v-for="(subItem, i) in item.subProjectList"
            >
              <div class="iconStyle">
                <span>{{ subItem.subProjectName }}</span>
                <van-icon name="arrow" />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="partners">
      <div
        :key="index"
        :style="'background-image:url(' + item.coverPicUrl + ')'"
        :data-id="item.id"
        v-for="(item, index) in showRoomCase"
        :class="curIndex === index ? 'partner active' : 'partner'"
      >
        <div class="title">{{ $t("算丰赋能伙伴案例") }}</div>
        <div class="rail-box"><div class="rail"></div></div>
        <div class="content">
          <div class="con-title">{{ item.caseName }}</div>
          <div class="con-desc">{{ item.caseDes }}</div>
          <a target="_blank" class="con-about" :href="item.caseDetailUrl">{{
            $t("了解详情")
          }}</a>
        </div>
      </div>
      <div class="list-item">
        <section
          :key="index"
          @click="selectCase(index)"
          :style="'background-image:url(' + item.coverPicUrl + ')'"
          v-for="(item, index) in showRoomCase"
        >
          <div
            class="progress"
            :class="curIndex === index ? 'in-pro progress' : 'progress'"
          >
            <svg viewBox="0 0 36 36" class="progress-circle">
              <path
                class="progress-bar"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              ></path>
            </svg>
          </div>
        </section>
      </div>
      <a
        target="_blank"
        href="https://mp.weixin.qq.com/mp/appmsgalbum?action=getalbum&__biz=Mzg3MTk4MDQxNA==&scene=1&album_id=2967374102212919298&count=3#wechat_redirect"
        class="more"
        >{{ $t("显示更多案例") }}<i class="el-icon-arrow-right"></i
      ></a>
    </div>
    <form-page></form-page>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "@/common/decorators.js";
import FormPage from "./solutionPage/Form.vue";
// import { store } from '../store.js'
@Component({ components: { FormPage } })
export default class Com extends Vue {
  firstLevel = [];
  showRoomCase = [];
  curIndex = 0;
  videoHasShow = true;
  mounted() {
    this.api.getFirstLevelShowroom();
    this.getCase();
    this.getFirstLevelShowroom();
    window.scroll(0, 0);
  }
  get lang() {
    return this.$store.state.lang;
  }
  @Watch("lang")
  onLangChange() {
    this.api.getFirstLevelShowroom();
    this.getFirstLevelShowroom();
    this.getCase();
    this.api.getFooterHeader();
  }

  @Debounce(300)
  async getFirstLevelShowroom() {
    let { Result } = await this.api.getFirstLevelShowroom().then(res => res);
    this.firstLevel = Result;
  }
  @Debounce(300)
  gotoDetail(item) {
    this.$router.push({ path: `/showroomDetail/${item}` });
  }
  @Debounce(300)
  async getCase() {
    let { Result } = await this.api.showroomCase().then(res => res);
    this.showRoomCase = Result;
    this.carousel();
  }
  @Debounce(300)
  async selectCase(index) {
    clearTimeout(this.timer);
    this.curIndex = index;
    this.carousel();
  }
  carousel() {
    let length = this.showRoomCase.length - 1;
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.curIndex < length) {
        this.curIndex = this.curIndex + 1;
      } else {
        this.curIndex = 0;
      }
      this.carousel();
    }, 5000);
  }
  unMounted() {
    this.timer && clearTimeout(this.timer);
  }
}
</script>

<style lang="scss" scoped>
.showRoom-bg /deep/ {
  background: #f5f7fa;
  height: auto;
  width: 100%;
  padding-bottom: 74px;
  padding-top: 84px;
  * {
    box-sizing: border-box;
    text-align: left;
  }
  .title {
    padding-top: 30px;
    font-size: 25px;
    font-weight: 600;
    color: #232325;
    line-height: 37px;
    text-align: center;
  }
  .subitle {
    font-weight: 400;
    color: #787878;
    line-height: 24px;
    text-align: center;
    margin-top: 14px;
    font-size: 18px;
    margin-bottom: 30px;
  }
  .main-block {
    .con-item {
      padding-bottom: 66.9%;
      margin-bottom: 15px;
      background-size: cover;
      box-sizing: border-box;
      position: relative;
      .sub-list {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0%;
        transition-property: height, top, background;
        transition-duration: 0.5s;
        padding: 0.3467rem;
        color: #ffffff;
        cursor: pointer;
        .sub-name {
          font-weight: 600;
          color: #ffffff;
          line-height: 41px;
          font-size: 24px;
          padding-left: 15px;
          transition: all 0.5s ease;
          transition-delay: 0.1s;
          opacity: 1;
          cursor: pointer;
          .iconfont {
            font-size: 15px;
            margin-right: 2px;
          }
        }
        .sub-item {
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
          padding-left: 15px;
          opacity: 0;
          transform: translateY(40px);
          -webkit-animation: fadeTop 0.4s linear forwards;
          animation: fadeTop 0.4s linear forwards;
          // transition: all 0.5s ease;
          // transition-delay: 0.1s;
          cursor: pointer;
          i {
            align-self: flex-end;
            padding-top: 5px;
            padding-right: 8px;
            transition: all 0.5s ease;
          }
          .iconStyle {
            justify-content: space-between;
            display: flex;
            flex-direction: row;
          }
          // &:hover {
          //   i {
          //     opacity: 1;
          //     padding-right: 0px;
          //   }
          // }
        }
      }
      // &:hover {
      //   .sub-list {
      //     height: 110%;
      //     opacity: 1;
      //     top: -10%;
      //     .sub-name {
      //       opacity: 1;
      //       transform: translateY(0px);
      //     }
      //     .sub-item {
      //       opacity: 1;
      //       transform: translateY(0px);
      //     }
      //   }
      //   .project-name {
      //     display: none;
      //   }
      // }
    }
  }
  .partners {
    position: relative;
    margin-top: 30px;
    height: 800px;
    .partner {
      width: 100%;
      padding-top: 50px;
      background-size: cover;
      position: absolute;
      padding-left: 20px;
      padding-right: 20px;
      display: none;
      opacity: 0;
      height: 100%;
      .title {
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
        // line-height: 50px;
      }
      .rail-box {
        text-align: center;
        line-height: 0;
        .rail {
          width: 92px;
          display: inline-block;
          height: 4px;
          background: #ffffff;
          border-radius: 4px;
        }
      }
      .content {
        .con-title {
          font-size: 20px;
          font-weight: 500;
          color: #ffffff;
          line-height: 33px;
          margin-top: 30px;
        }
        .con-desc {
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 28px;
          margin-top: 22px;
          margin-bottom: 20px;
        }
        .con-about {
          border: 1px solid #ffffff;
          padding: 6px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          line-height: 20px;
        }
      }
    }
    .active {
      opacity: 0;
      display: block;
      -webkit-animation: fadeIn 0.4s linear forwards;
      animation: fadeIn 0.4s linear forwards;
    }
    .list-item {
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      section {
        width: 28px;
        height: 28px;
        margin: 6px;
        cursor: pointer;
        background-size: cover;
        border-radius: 50%;
        .progress {
          stroke-dasharray: 100 100;
          stroke-dashoffset: 0;
          stroke: #fff;
          stroke-linecap: round;
          fill: transparent;
          -webkit-animation: progress 5s linear forwards;
          animation: progress 5s linear forwards;
          height: 100%;
          display: none;
          left: -5px;
          position: relative;
          top: -5px;
          width: 100%;
          .progress-circle {
            height: calc(100% + 10px);
            width: calc(100% + 10px);
          }
        }
        .in-pro {
          display: block;
        }
        &:hover {
          -webkit-transform: scale(1.05);
          transform: scale(1.05);
        }
      }
    }
    .more {
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;
      line-height: 17px;
      position: absolute;
      bottom: 7%;
      text-align: center;
      width: 100%;
    }
  }
  @-webkit-keyframes progress {
    0% {
      stroke-dashoffset: 100;
    }

    50% {
      stroke-dashoffset: 50;
    }

    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes progress {
    0% {
      stroke-dashoffset: 100;
    }

    50% {
      stroke-dashoffset: 50;
    }

    to {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadeTop {
    0% {
      opacity: 0;
      transform: translateY(40px);
    }

    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @keyframes fadeTop {
    0% {
      opacity: 0;
      transform: translateY(40px);
    }

    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
}
</style>
